import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { DomainID } from '~src/settings/bridge-settings/sections/types/Domain';
import { PoolID, SystemDefinedPoolID } from '~src/settings/bridge-settings/sections/types/PoolID';
import { AgentID } from '~src/settings/types/ISiteAdminBridgeSettings';

import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { EdgePoolError } from '../../sections/types/EdgePoolError';

export enum DomainUpdateType {
  Add = 'ADD',
  Remove = 'REMOVE'
}

export interface IUpdateEdgePoolParams {
  poolId: PoolID | SystemDefinedPoolID.Unassigned | SystemDefinedPoolID.Default | SystemDefinedPoolID.Blocked;
  displayName?: string;
  domainChange?: { change: DomainUpdateType.Add | DomainUpdateType.Remove, domainId: DomainID };
  agentChange?: { agentId: AgentID };
  bridgeSettingsVersion: string;
  siteId: string;
}

export interface IUpdateEdgePoolResult extends IResult {
  success?: {
    poolId: PoolID | SystemDefinedPoolID.Unassigned | SystemDefinedPoolID.Default | SystemDefinedPoolID.Blocked;
    displayName?: string;
    domainId?: DomainID;
    agentId?: AgentID;
    siteID: string;
  };
  error?: EdgePoolError;
  bridgeSettingsVersion: string;
}

export class UpdateEdgePoolRequest extends Request<IUpdateEdgePoolParams, IUpdateEdgePoolResult> {
  constructor(params: IUpdateEdgePoolParams) {
    super('updateEdgePool', params);
  }
}
